<script setup lang="ts">
/**
 * The submit/CTA button of the auth flow (Figma `66:46895`, `66:47209`).
 *
 * Not `FairButton`: that primitive carries the v1 button scale — `.fair-text-button`
 * is Gilroy 19px with -0.05em tracking and `--rounded="false"` resolves to a
 * 12px radius. This flow is drawn on `type/button` (Gilroy Medium 14, +2%) in a
 * 38px shell with `radius/control` 4px. Rather than bend the shared primitive
 * for one screen, the flow owns its own control; the styles live in
 * `fair-auth-modal.css`.
 */
withDefaults(defineProps<{
  label: string
  /** `tonal` is the de-emphasised CTA — "Resend link" (`66:47118`). */
  variant?: 'primary' | 'tonal'
  type?: 'button' | 'submit'
  disabled?: boolean
}>(), {
  variant: 'primary',
  type: 'button',
  disabled: false,
})

const emit = defineEmits<{ click: [MouseEvent] }>()
</script>

<template>
  <button
    :type="type"
    :class="['fair-auth-button', `fair-auth-button--${variant}`]"
    :disabled="disabled"
    @click="emit('click', $event)"
  >
    <slot name="icon" />
    {{ label }}
  </button>
</template>
